var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense, useEffect, useState, useContext } from 'react';
import { Link, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { NavBar, Space, Image } from 'antd-mobile';
import intl from 'react-intl-universal';
import Context from '@/context/createContext';
import classnames from 'classnames';
import { mobileRoutes, signatureFooter, paymentFooter } from './systemRoutes';
import Exception from '@/components/Exception';
import './index.less';
var routes = mobileRoutes.map(function (_a) {
    var trunk = _a.trunk, config = __rest(_a, ["trunk"]);
    var Trunk = lazy(function () { return trunk(); });
    return __assign(__assign({}, config), { component: (_jsx(Suspense, __assign({ fallback: _jsx("div", { children: "Loading..." }) }, { children: _jsx(Trunk, {}) }))) });
});
var Mobile = function (_a) {
    var setVisibleHeader = _a.setVisibleHeader, headerTitle = _a.headerTitle, setHeaderTitle = _a.setHeaderTitle, error = _a.error, errorInfo = _a.errorInfo, currentPath = _a.currentPath, setCurrentPath = _a.setCurrentPath;
    var _b = useContext(Context), invoiceInfo = _b.invoiceInfo, patientInfo = _b.patientInfo, type = _b.type;
    var _c = useState(false), backArrow = _c[0], setBackArrow = _c[1];
    var _d = useState(false), visibleCommonHeader = _d[0], setVisibleCommonHeader = _d[1];
    var _e = useState(true), visibleFooter = _e[0], setVisibleFooter = _e[1];
    var _f = useState([]), footer = _f[0], setFooter = _f[1]; // 存储footer路由
    var location = useLocation();
    var history = useHistory();
    useEffect(function () {
        var userAgentObj = JSON.parse(localStorage.getItem('userAgentObj')) || null;
        // 签字页面
        switch (currentPath) {
            case '/sign':
                setVisibleFooter(false);
                setVisibleCommonHeader(true);
                setBackArrow(true);
                setHeaderTitle(intl.get('signHeader'));
                break;
            case '/billDetail':
                setVisibleFooter(false);
                setVisibleCommonHeader(false);
                setBackArrow(false);
                setHeaderTitle(intl.get('company'));
                break;
            case '/invoicePDF':
                setVisibleFooter(false);
                setVisibleCommonHeader(true);
                setBackArrow(true);
                setHeaderTitle(intl.get('company'));
                break;
            default:
                setVisibleCommonHeader(true);
                setBackArrow(false);
                if (userAgentObj && (userAgentObj.isWeiXin || userAgentObj.isZfb)) {
                    setVisibleCommonHeader(false);
                }
                setHeaderTitle(intl.get('company'));
                setVisibleFooter(true);
                break;
        }
    }, [currentPath]);
    // 根据type确定footer的路由
    useEffect(function () {
        switch (type) {
            // 追签
            case 'signature':
                setFooter(signatureFooter);
                break;
            //追账
            case 'payment':
                setFooter(paymentFooter);
                break;
            default:
                break;
        }
    }, [type]);
    // 跳转路由
    var jumpRouter = function (pathName) {
        setCurrentPath(pathName);
    };
    // 返回
    var back = function () { return history.go(-1); };
    return (_jsxs("div", __assign({ className: classnames('mobileWrap', currentPath === '/' ? 'main' : currentPath.split('/')[1], type) }, { children: [visibleCommonHeader && (_jsx("header", { children: _jsx(NavBar, __assign({ backArrow: backArrow, onBack: back }, { children: headerTitle })) })), error ? (_jsx(Exception, { type: errorInfo.type, title: errorInfo.title, description: errorInfo.description })) : (_jsx("main", { children: _jsxs(Switch, { children: [routes.map(function (item) { return (_jsx(Route, { path: item.path, exact: item.exact, render: function () { return item.component; } }, item.path)); }), _jsx(Route, __assign({ path: '*', exact: true }, { children: _jsx(Exception, { type: 'error', title: 'error', description: '' }) }))] }) }, location.key)), visibleFooter && (_jsx("footer", { children: footer.length > 0 &&
                    footer.map(function (itemRoute) { return (_jsx("div", __assign({ className: classnames('itemRoute', (itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName) === currentPath && 'activePath', (currentPath === '/' || currentPath === '/main') && (itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName) === '/' && 'activePath'), onClick: function () { return jumpRouter(itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName); } }, { children: _jsxs(Link, __assign({ to: { pathname: itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName, search: location.search, state: undefined } }, { children: [_jsx(Space, __assign({ style: { fontSize: 20 }, className: 'icon' }, { children: (itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName) === currentPath || ((currentPath === '/' || currentPath === '/main') && (itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName) === '/') ? (_jsx(Image, { src: "".concat(itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.activeIcon), width: 20, height: 20 })) : (_jsx(Image, { src: "".concat(itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.icon), width: 20, height: 20 })) })), _jsx("span", { children: intl.get(itemRoute.title) })] })) }), itemRoute === null || itemRoute === void 0 ? void 0 : itemRoute.pathName)); }) }))] })));
};
export default Mobile;
